import React, { Component } from "react";

import { withSavedReports } from "./../../../shared/containers/containerSavedReports";
import { withFilterSavedReports } from "../../../shared/containers/containerFilterSavedReports";
import { withDeleteReport } from "./../../../shared/containers/containerDeleteReport";
import DownloadReportsModal from "./downloadReportsModal";

import SavedReportItem from "./savedReportItem";
import DeleteSavedReportBtn from "./deleteSavedReportBtn";
import Preloader from "./../../../shared/items/static/preloader";

import { states } from "./../../../reducers/queriesStates";

import styles from "./listSavedReports.module.scss";

class ListSavedReports extends Component {
  componentDidMount() {
    const { onGetSavedReports, filterSavedReportsPage, filterSavedReportsCount } = this.props;
    let filterItems = { page: filterSavedReportsPage, count: filterSavedReportsCount };

    onGetSavedReports(filterItems);
  }

  componentDidUpdate(prevProps) {
    const {
      savedReportsData,
      deleteReportDataState,
      onGetSavedReports,
      filterSavedReportsDataState,
      filterSavedReportsPage,
      filterSavedReportsCount,
      onHandleChangeSavedReportsFilter,
    } = this.props;
    let filterItems = { page: filterSavedReportsPage, count: filterSavedReportsCount };

    if (prevProps.filterSavedReportsDataState !== states.READY && filterSavedReportsDataState === states.READY)
      onGetSavedReports(filterItems);

    if (deleteReportDataState === states.READY && prevProps.deleteReportDataState !== states.READY) {
      if (savedReportsData.length === 1) {
        onHandleChangeSavedReportsFilter(filterSavedReportsPage - 1);
      } else {
        onGetSavedReports(filterItems);
      }
    }
  }

  formatData(item) {
    const { reportsList } = this.props;
    const data = Object.assign({}, item);

    data.reportType = reportsList.find((itemType) => itemType.id === item.reportId);

    return data;
  }

  render() {
    const { savedReportsDataState, savedReportsData } = this.props;

    return (
      <div className={styles.wrapper_savedReportsList}>
        {savedReportsDataState === states.READY ? (
          savedReportsData.map((item) => {
            return <SavedReportItem data={this.formatData(item)} key={item.id} btnClose={<DeleteSavedReportBtn itemId={item.id} />} />;
          })
        ) : (
          <div className={styles.container_preloader}>
            <Preloader />
          </div>
        )}
        <DownloadReportsModal />
      </div>
    );
  }
}

export default withFilterSavedReports(withSavedReports(withDeleteReport(ListSavedReports)));
